module.exports = __webpack_public_path__ + "static/media/pencil.3d7657a6.svg";